import React, { useState, useEffect } from 'react';
import posed from 'react-pose';
import { useMediaQuery } from 'react-responsive';
import VisibilitySensor from 'react-visibility-sensor';
import { useTranslation } from 'react-i18next';
import Block from '../Components/Block/Block';
import s from './Page.module.scss';
import phone1 from '../Resources/phones.png';
import phone1max from '../Resources/phones@2x.png';
import phone2 from '../Resources/phones_2.png';
import phone2max from '../Resources/phones_2@2x.png';
import phone3 from '../Resources/phones_3.png';
import phone3max from '../Resources/phones_3@2x.png';
import bg1 from '../Resources/bg1.png';
import bg2 from '../Resources/bg2.png';
import bg3 from '../Resources/bg3.png';
// eslint-disable-next-line import/no-unresolved
import { MainApi } from '../API';
import useWindowDimensions from '../Hooks/useWindowDimensions';

const Phone = posed.div({
  enter: { opacity: 1, y: '-50%', x: 220, transition: { duration: 500 } },
  exit: {
    opacity: 0,
    y: '-50%',
    x: 400,
    transition: { duration: 500 }
  }
});

const Blocks = ({notification}) => {
  const { t } = useTranslation();
  const { height } = useWindowDimensions();

  const [fixLengthItems, setFixLengthItems] = useState([]);
  const [infiniteLengthItems, setInfiniteLengthItems] = useState([]);
  const [difficultyLengthItems, setDifficultyLengthItems] = useState([]);
  const [showPhone, setShowPhone] = useState(false);
  const [phones, setPhones] = useState([phone1, phone1max]);
  const isMobile = useMediaQuery({
    query: '(max-width: 1200px)'
  });

  const formatTime = timeMilliseconds => {
    let h = Math.floor(timeMilliseconds / 3600000);
    if (h < 10) {
      h = `0${h}`
    }
    let m = Math.floor(timeMilliseconds % 3600000 / 60000);
    if (m < 10) {
      m = `0${m}`
    }
    let s = Math.floor(timeMilliseconds % 60000 / 1000);
    if (s < 10) {
      s = `0${s}`
    }
    let ms = Math.floor(timeMilliseconds % 1000);// 1
    if (ms < 10) {
      ms = `00${ms}`
    } else if (ms < 100) {
      ms = `0${ms}`
    }
    return `${h}:${m}:${s}.${ms}`;
  }

  useEffect(() => {
    if (notification === null) {
      const api = new MainApi({
        basePath: `${window.config.ENDPOINT}/Gamification`
      });
      api.getTop('FixLengthSwype').then(result => setFixLengthItems(result.data));
      api
        .getTop('InfiniteLengthSwype')
        .then(result => setInfiniteLengthItems(result.data));
      api
        .getTop('InfiniteLengthSwypeIncreasingDifficulty')
        .then(result => setDifficultyLengthItems(result.data));
    }

    if (notification && notification.current.usersBestResult) {
      switch(notification.current.gameType) {
        case 'FixLengthSwype':
          const newFixLengthItems = fixLengthItems.map(function(item) {
            if (item.userCode === notification.userCode) {
              item.score = notification.current.score;
              item.time = formatTime(notification.current.timeMilliseconds)
            }
            return item;
          })
          setFixLengthItems(newFixLengthItems);
          break
        case 'InfiniteLengthSwype':
          const newInfiniteLengthItems = infiniteLengthItems.map(function(item) {
            if (item.userCode === notification.userCode) {
              item.score = notification.current.score;
              item.time = formatTime(notification.current.timeMilliseconds)
            }
            return item;
          })
          setInfiniteLengthItems(newInfiniteLengthItems);
          break
        case 'InfiniteLengthSwypeIncreasingDifficulty':
          const newDifficultyLengthItems = difficultyLengthItems.map(function(item) {
            if (item.userCode === notification.userCode) {
              item.score = notification.current.score;
              item.time = formatTime(notification.current.timeMilliseconds)
            }
            return item;
          })
          setDifficultyLengthItems(newDifficultyLengthItems);
          break
      }
    }
  }, [notification]);

  const visibilityChange = isVisible => setShowPhone(isVisible);

  const updatePhones = value => isVisible => isVisible && setPhones(value);

  const blockOffset = { bottom: (height - 200) / 2, top: (height - 200) / 2 };

  return (
    <VisibilitySensor
      onChange={visibilityChange}
      partialVisibility
      minTopValue={isMobile ? 450 : 530}
      offset={{ top: 400 }}
    >
      <div className={s.blocks}>
        <VisibilitySensor
          partialVisibility
          offset={blockOffset}
          onChange={updatePhones([phone1, phone1max])}
        >
          <Block
            title={t('game_1')}
            backgroundImage={bg1}
            items={fixLengthItems}
            game={1}
          >
            {t('game_1_info')}
          </Block>
        </VisibilitySensor>
        <VisibilitySensor
          partialVisibility
          offset={blockOffset}
          onChange={updatePhones([phone2, phone2max])}
        >
          <Block
            title={t('game_2')}
            backgroundImage={bg2}
            items={infiniteLengthItems}
            game={2}
          >
            {t('game_2_info')}
          </Block>
        </VisibilitySensor>
        <VisibilitySensor
          partialVisibility
          offset={blockOffset}
          onChange={updatePhones([phone3, phone3max])}
        >
          <Block
            title={t('game_3')}
            backgroundImage={bg3}
            items={difficultyLengthItems}
            game={3}
          >
            {t('game_3_info')}
          </Block>
        </VisibilitySensor>
        <Phone key={1} className={s.phone} pose={showPhone ? 'enter' : 'exit'}>
          <img src={isMobile ? phones[0] : phones[1]} alt="" />
        </Phone>
      </div>
    </VisibilitySensor>
  );
};

export default Blocks;
